import styled from "styled-components"

const Line = styled.div<{ white?: boolean }>`
  height: 2px;
  width: 100%;
  background-color: ${({ white }) => (white ? "white" : "black")};
`

export default Line
